export default __webpack_public_path__ + "static/media/img-lawyer-mobile.c9c9607f.jpg";